var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 14.4167H9.33334V11.0834H12.6667V12.75M12.6667 14.4167L15.3333 18.4167M12.6667 14.4167V12.75M15.3333 18.4167H18.6667V21.75H15.3333V18.4167ZM12.6667 12.75H19.3333M19.3333 12.75V14.4167H22.6667V11.0834H19.3333V12.75Z",
    stroke: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteGrey);
export default __webpack_public_path__ + "static/media/siteGrey.826115a2ed5072841b01897f19a3e572.svg";
export { ForwardRef as ReactComponent };